import { createSelector, ParametricSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type isLoadingKeyType = 'isListLoading' | 'isUpdateLandingsTasksLoading'

const getIsLoadingSelectorByKey: ParametricSelector<ReduxState, isLoadingKeyType, boolean> = (state, isLoadingKey) =>
  state.tasksQueue.UIState[isLoadingKey] || false

export const isLoadingSelector = createSelector(getIsLoadingSelectorByKey, isLoading => isLoading)
